// extracted by mini-css-extract-plugin
module.exports = {"select_wrapper":"StatefulDialog_select_wrapper__aStiu","dialog_element":"StatefulDialog_dialog_element__h6q2N"};